export default "__VITE_ASSET__l2_c9cWl__"